import { SubmitManualPaymentUnion } from '@varo/graphql-schema-types';
import SubmitLineOfCreditPayment from 'services/graphql/mutations/SubmitLineOfCreditPayment';
import { useMutation } from 'urql';

interface LineOfCreditPaymentResult {
  submitManualPaymentForLineOfCredit: SubmitManualPaymentUnion;
}

const useSubmitLineOfCreditPayment = () => {
  const [{ data, fetching, error }, executeMutation] =
    useMutation<LineOfCreditPaymentResult>(SubmitLineOfCreditPayment);
  return {
    data,
    fetching,
    error,
    executeMutation,
  };
};

export default useSubmitLineOfCreditPayment;
